import { TRPCClientError } from "@trpc/client";
import type { AdminWhoami } from "./staff-types";
import { getSupabaseClient } from "./supabase";
import { getTrpcClient, hasTrpcConfig } from "./trpc";

export class StaffForbiddenError extends Error {
	constructor(message = "管理画面へのアクセス権限がありません。") {
		super(message);
		this.name = "StaffForbiddenError";
	}
}

export async function getAccessToken(): Promise<string | null> {
	const { data, error } = await getSupabaseClient().auth.getSession();
	if (error) {
		console.error("getAccessToken getSession error:", error);
		return null;
	}
	return data.session?.access_token ?? null;
}

export async function fetchWhoami(): Promise<AdminWhoami> {
	if (!hasTrpcConfig()) {
		throw new Error("VITE_TRPC_URL / VITE_SUPABASE_URL が未設定です。");
	}

	const accessToken = await getAccessToken();
	if (!accessToken) {
		throw new Error("サインインが必要です。");
	}

	try {
		return await getTrpcClient(accessToken).admin.whoami.query();
	} catch (err) {
		if (err instanceof TRPCClientError && err.data?.code === "FORBIDDEN") {
			throw new StaffForbiddenError(err.message);
		}
		throw err;
	}
}
